import React, { useState, useEffect, useRef } from "react";

const FilterControls = ({ onFilterChange, totalScales, filteredCount }) => {
  const [patternSearch, setPatternSearch] = useState("");
  const [showExamples, setShowExamples] = useState(false);
  const debounceTimer = useRef(null);

  const handlePatternChange = (e) => {
    const value = e.target.value.toLowerCase();
    setPatternSearch(value);
    
    // Clear existing timer
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    
    // Set new timer - 300ms is good for typing speed
    debounceTimer.current = setTimeout(() => {
      onFilterChange({ pattern: value });
    }, 300);
  };

  const clearFilters = () => {
    setPatternSearch("");
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    onFilterChange({ pattern: "" });
  };
  
  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, []);

  return (
    <div className="filter-controls">
      <div className="filter-controls-inline">
        <div className="pattern-search-container">
          <input
            id="pattern-search"
            type="text"
            value={patternSearch}
            onChange={handlePatternChange}
            placeholder="Filter: 123, min5, s3m2, ^21..."
            className="pattern-input"
          />
          {patternSearch && (
            <button
              type="button"
              onClick={clearFilters}
              className="clear-pattern"
              title="Clear filters"
            >
              ×
            </button>
          )}
        </div>
        
        <button 
          type="button"
          className="toggle-examples"
          onClick={() => setShowExamples(!showExamples)}
          title="Show filter examples"
        >
          ?
        </button>
      </div>
      
      <div className="filter-count">
        {filteredCount !== totalScales ? (
          <><span className="filtered-count">{filteredCount}</span> of {totalScales} scales</>
        ) : (
          <>{totalScales} scales</>
        )}
      </div>
      
      {showExamples && (
        <div className="pattern-examples">
          <div className="example-item"><code>123</code> contains 1-2-3</div>
          <div className="example-item"><code>^21</code> starts with 2-1</div>
          <div className="example-item"><code>min5</code> 5+ notes</div>
          <div className="example-item"><code>max8</code> ≤8 notes</div>
          <div className="example-item"><code>s5</code> superscale #5</div>
          <div className="example-item"><code>m3</code> mode 3</div>
          <div className="example-item"><code>n42</code> scale #42</div>
          <div className="example-item"><code>12,21</code> 1-2 OR 2-1</div>
          <div className="example-item"><code>12&^3</code> 1-2 AND starts with 3</div>
        </div>
      )}
    </div>
  );
};

export default FilterControls;
